import templateStr from 'text!./bop-location-directive.html';
import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';
import _ from 'underscore';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            location: '=',
            remove: '&',
            jobId: '=',
            selectedBuildingId: '=',
            isAccordionOpen: '=',
            submissionViewModel: '=',
            initialPage: '='
        },
        controller: ['$scope', 'InsuranceSuiteMetadata', '$filter', 'ModalService', '$state', 'qnb.bopCoverablesService', function ($scope, insuranceSuiteMetadata, $filter, ModalService, $state, BOPCoverablesService) {
            var typelist = insuranceSuiteMetadata.get('pc').types.getTypelist('FireProtectClass');
            $scope.location.displayAddress = $scope.location.displayName.split(',');
            $scope.fireProtection = $scope.location.fireProtection ? typelist.getCode($scope.location.fireProtection).name : null;
            $scope.buildingFormIsOpen = {
                isOpen: false
            };

            $scope.goToAddBuilding = function () {
                return $state.go('building', { building: null, location: $scope.location, initialPage: $scope.initialPage });
            };

            $scope.$watch('building.hasAlarm.value', _.after(2, function (hasAlarm) {
                if (!hasAlarm) {
                    // If alarm toggle is no, unset the alarm type
                    $scope.buildingView.alarmType.set(undefined);
                }
            }));

            $scope.handleRemove = function () {
                if ($scope.location.buildings.length > 0) {
                    ModalService.showError('quoteandbind.bop.views.bop-buildings-locations.Unable to remove a location that has buildings', 'quoteandbind.bop.views.bop-buildings-locations.Please remove buildings and try again');
                } else {
                    ModalService.showConfirm('quoteandbind.bop.directives.bop-location-directive.RemoveLocationTitle', 'quoteandbind.bop.directives.bop-location-directive.RemoveLocationMessage', undefined, $filter('translate')('quoteandbind.bop.directives.bop-location-directive.RemoveActionLabel')).result.then(function () {
                        return $scope.remove()();
                    });
                }
            };

            $scope.removeBuilding = function (building) {
                return function () {
                    $scope.operation = BOPCoverablesService.removeBOPBuilding($scope.jobId, $scope.location.publicID, building.publicID, SessionUtil.getSessionUUID($scope.submissionViewModel));
                    $scope.operation.then(function () {
                        $scope.location.buildings.splice($scope.location.buildings.indexOf(building), 1);
                    }).catch(function () {
                        ModalService.showError('quoteandbind.bop.Unable to remove building', 'quoteandbind.bop.Please check for errors and try again');
                    });
                };
            };

            $scope.editBuilding = function (building) {
                return function () {
                    return $state.go('building', { building: building, location: $scope.location, initialPage: $scope.initialPage });
                };
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/locationsAndBuildings/directives/bop-location-directive/BOPLocationDirective.js
// module id = 1809
// module chunks = 0